import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class RedirectV2Props {
  @Inlet(Accepts.RedirectOptionList)
  public options?: Types["RedirectOptionList"];

  @Inlet(Accepts.Boolean) public quitStory?: Types["Boolean"];

  @Inlet(Accepts.Image) public image?: Types["Image"];

  @Inlet(Accepts.String) public pretext?: string;
  @Inlet(Accepts.String) public title?: string;
}

export const RedirectV2Definition = defineElement(
  "redirect-v2",
  RedirectV2Props,
  {
    versionRequired: "0.58.0",
  }
);
